// This file exports from the platform-specific implementation
// Expo Router requires a fallback file when platform extensions are used
export { default, ErrorBoundary } from "./_layout.web";
